import type { AddonNames, Lineup, PlanNames, ProductNames } from '#pricing/types';

export const ADDON_CODES: Record<
  AddonNames,
  'accounts_receivable' | 'accounts_payable' | 'expense_spend_management' | 'cash_flow_management'
> = {
  AccountsReceivable: 'accounts_receivable',
  AccountsPayable: 'accounts_payable',
  ExpenseSpendManagement: 'expense_spend_management',
  CashFlowManagement: 'cash_flow_management',
} as const;

export const PRICE_PLAN_CODES: Record<
  PlanNames,
  | 'solo_basic_2024'
  | 'solo_smart_2024'
  | 'solo_premium_2024'
  | 'team_essential_2024'
  | 'team_business_2024'
  | 'team_enterprise_2024'
  | 'solo_payg_2026'
> = {
  SoloBasic: 'solo_basic_2024',
  SoloSmart: 'solo_smart_2024',
  SoloPremium: 'solo_premium_2024',
  TeamEssential: 'team_essential_2024',
  TeamBusiness: 'team_business_2024',
  TeamEnterprise: 'team_enterprise_2024',
  Starter: 'solo_payg_2026',
} as const;

export const ADDON_GROUP_CODES: Record<
  AddonNames,
  'accounts_receivable' | 'accounts_payable' | 'expense_spend_management' | 'cash_flow_management'
> = {
  AccountsReceivable: 'accounts_receivable',
  AccountsPayable: 'accounts_payable',
  ExpenseSpendManagement: 'expense_spend_management',
  CashFlowManagement: 'cash_flow_management',
} as const;

export const PRODUCT_CODES: Record<
  ProductNames,
  | 'solo_basic_2024'
  | 'solo_smart_2024'
  | 'solo_premium_2024'
  | 'team_essential_2024'
  | 'team_business_2024'
  | 'team_enterprise_2024'
  | 'accounts_receivable'
  | 'accounts_payable'
  | 'expense_spend_management'
  | 'cash_flow_management'
  | 'solo_payg_2026'
> = {
  ...ADDON_CODES,
  ...PRICE_PLAN_CODES,
} as const;

export const PRICE_PLANT_TRAITS: Record<
  'Active' | 'FreeTrial' | 'Recommended' | 'Popular' | 'Promo',
  'active' | 'free_trial' | 'recommended' | 'popular' | 'promo'
> = {
  Active: 'active',
  FreeTrial: 'free_trial',
  Recommended: 'recommended',
  Popular: 'popular',
  Promo: 'promo',
} as const;

/**
 * @deprecated Use string literals 'solo' and 'teams' instead when in TS
 */
export const PRICE_PLAN_LINEUPS: Record<'SOLO' | 'TEAMS', Lineup> = {
  SOLO: 'solo',
  TEAMS: 'teams',
};

export const PRODUCT_TEST_IDS: Record<
  ProductNames,
  | 'solo_basic_2024_id'
  | 'solo_smart_2024_id'
  | 'solo_premium_2024_id'
  | 'team_essential_2024_id'
  | 'team_business_2024_id'
  | 'team_enterprise_2024_id'
  | 'accounts_receivable_id'
  | 'accounts_payable_id'
  | 'expense_spend_management_id'
  | 'cash_flow_management_id'
  | 'starter_id'
> = {
  SoloBasic: 'solo_basic_2024_id',
  SoloSmart: 'solo_smart_2024_id',
  SoloPremium: 'solo_premium_2024_id',
  TeamEssential: 'team_essential_2024_id',
  TeamBusiness: 'team_business_2024_id',
  TeamEnterprise: 'team_enterprise_2024_id',
  AccountsReceivable: 'accounts_receivable_id',
  AccountsPayable: 'accounts_payable_id',
  ExpenseSpendManagement: 'expense_spend_management_id',
  CashFlowManagement: 'cash_flow_management_id',
  Starter: 'starter_id',
} as const;

export const PRODUCT_GROUP_CODES: Record<
  ProductNames,
  | 'solo_basic'
  | 'solo_smart'
  | 'solo_premium'
  | 'team_essential'
  | 'team_business'
  | 'team_enterprise'
  | 'accounts_receivable'
  | 'accounts_payable'
  | 'expense_spend_management'
  | 'cash_flow_management'
  | 'solo_payg'
> = {
  SoloBasic: 'solo_basic',
  SoloSmart: 'solo_smart',
  SoloPremium: 'solo_premium',
  TeamEssential: 'team_essential',
  TeamBusiness: 'team_business',
  TeamEnterprise: 'team_enterprise',
  AccountsReceivable: 'accounts_receivable',
  AccountsPayable: 'accounts_payable',
  ExpenseSpendManagement: 'expense_spend_management',
  CashFlowManagement: 'cash_flow_management',
  Starter: 'solo_payg',
} as const;
